import React, { useState, useImperativeHandle, forwardRef } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom'

//images
import tryAgainImg from '../../../assets/images/success/try-again-img.jpg';

function CompletedTest(props, ref) {

    const [major, setMajor] = useState({
        blur: false,
        popup: false,
        href: '',
    })

    useImperativeHandle(ref, () => ({
        open: href => {
            handleOpen(href)
        },
        close: () => {
            handleClose()
        }
    }))

    const handleOpen = href => {
        setMajor(major => ({
            ...major,
            blur: true,
            href: href
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                popup: true
            }))
        }, 50);
    }

    const handleClose = () => {
        setMajor(major => ({
            ...major,
            popup: false
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                blur: false,
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={major.blur ? 'visible' : ''}>
            <div className={`box complete-test ${major.popup ? 'show' : ''}`}>
                <img src={tryAgainImg} className="main-img" />
                <h3>
                    Гледай Видео лекциите от Тема 1
                </h3>
                <p>
                    Авто Обучение ти помага да усвоиш материала много по-лесно и да се справиш отлично с изпитните въпроси.
                </p>
                <div className="buttons">
                    <Button>
                        <Link to="/topic?topic_id=1&video_id=o59AvgSd">
                            Към Видео Лекциите
                        </Link>
                    </Button>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(CompletedTest);